var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?[_c('Tabs',{ref:"Tabs",attrs:{"data":{ additionals: _vm.additionals, form: _vm.form, model: _vm.model }}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }